// src/hooks/useRoles.ts
import { useAuth } from '@/contexts/AuthContext';

export const ROLES = {
  SUPER_ADMIN:     'super_admin',
  ADMIN:           'admin',
  SUPPORT_STAFF:   'support_staff',
  ENTERPRISE_USER: 'enterprise_user',
  TEAM_MEMBER:     'team_member',
  PRIVATE_USER:    'private_user',
  // Startup programme: reviews applications at /programme. Not an admin.
  PROGRAMME_OFFICER: 'programme_officer',
} as const;

export function useRoles() {
  const { user } = useAuth();
  const roles = user?.roles ?? [];

  return {
    roles,
    isSuperAdmin:     roles.includes(ROLES.SUPER_ADMIN),
    isAdmin:          roles.includes(ROLES.ADMIN) || roles.includes(ROLES.SUPER_ADMIN),
    isSupportStaff:   roles.includes(ROLES.SUPPORT_STAFF),
    isEnterpriseUser: roles.includes(ROLES.ENTERPRISE_USER),
    isTeamMember:     roles.includes(ROLES.TEAM_MEMBER),
    isPrivateUser:    roles.includes(ROLES.PRIVATE_USER),
    hasRole:          (role: string) => roles.includes(role),
    hasAnyRole:       (...check: string[]) => check.some(r => roles.includes(r)),
  };
}
